module.exports = {
      id: "block-circle-icon-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#block-circle-icon",
      toString: function () {
        return this.url;
      }
    }